<template>
    <div>
        <promotion-banners />
        <intro-service-landing v-if="!$device.mobile" />
        <breaking-news-landing />
        <tour-home-cards />
        <template v-if="!$device.mobile">
            <application-landing-section />
            <partner-airline-section />
            <seo-links />
        </template>
        <template v-for="(section, index) in content.sections">
            <text-box v-if="section.type === 'text'"
                      :text="section.content.text"
                      :img="section.content.img"
                      :full="section.content.full"
                      :heading="section.content.heading"
                      :heading-tag="section.headingTag"
                      :key="index"
            />
            <faq v-if="section.type === 'FAQ'"
                 :key="index"
                 :items="section.content.items"
                 :heading="section.content.heading"
                 :has-json-ld="section.content.hasJsonLD"
            />
        </template>
    </div>
</template>

<script>
// child components
import SeoLinks from '~/components/pages/home/seo-links';
import PartnerAirlineSection from '~/components/pages/home/partner-airline-section';
import ApplicationLandingSection from '~/components/pages/home/application-landing-section';
import BreakingNewsLanding from '~/components/pages/home/breaking-news-landing';
import IntroServiceLanding from '~/components/pages/home/intro-service-landing';
import PromotionBanners from '~/components/pages/home/promotion-banners';
import TourHomeCards from '~/components/pages/tour/tour-home-cards';
import TextBox from '~/components/pages/landing/text-box/text-box';
import Faq from '~/components/pages/landing/faq/faq';
import content from '~/static/domestic-landings/homepage';

export default {
    name: 'DomesticHomePage',
    components: {
        SeoLinks,
        PartnerAirlineSection,
        ApplicationLandingSection,
        BreakingNewsLanding,
        IntroServiceLanding,
        PromotionBanners,
        TourHomeCards,
        TextBox,
        Faq,
    },
    data () {
        return {
            content,
        };
    },

    head () {
        return {
            title: this.content.title,
            meta: [
                { hid: 'description', name: 'description', content: this.content.meta.description },
                { hid: 'og:description', name: 'og:description', content: this.content.meta.description },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
@import '~vars';

/deep/ .c-text-box {

    .section-heading {
        text-align: center;
    }

    .box-text h2 {
        font-size: 1.1428em;
        font-weight: 700;
        line-height: 1.1428em;
    }
}
</style>
